import * as CartService from '../services/CartService'

export const REMOVE_ITEM_REQUEST = 'REMOVE_ITEM_REQUEST';
export const REMOVE_ITEM_SUCCESS = 'REMOVE_ITEM_SUCCESS';
export const REMOVE_ITEM_FAILURE = 'REMOVE_ITEM_FAILURE';

export function removeItemRequest(identifier) {
    return {
        type: REMOVE_ITEM_REQUEST,
        identifier
    }
}

export function removeItemSuccess(payload) {
    return {
        type: REMOVE_ITEM_SUCCESS,
        payload
    }
}

export function removeItemFailure(payload) {
    return {
        type: REMOVE_ITEM_FAILURE,
        payload
    }
}

export function removeItem(identifier) {
    return (dispatch) => {
        dispatch(removeItemRequest(identifier));

        CartService.removeItem(identifier)
            .then(response => {
                dispatch(removeItemSuccess(response));
            })
            .catch(error => {
                dispatch(removeItemFailure(error));
            });
    }
}
